/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateMeetingCommandResult } from '../../models/update-meeting-command-result';

export interface ApiMeetingsUpdateMeetingPut$Params {
      body?: {
'Id'?: string;
'Name'?: string;
'Description'?: string;
'Place'?: string;
'Axes'?: string;
'Dauration'?: number;
'MeetingUsers'?: Array<string>;
'Date'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiMeetingsUpdateMeetingPut(http: HttpClient, rootUrl: string, params?: ApiMeetingsUpdateMeetingPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateMeetingCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiMeetingsUpdateMeetingPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateMeetingCommandResult>;
    })
  );
}

apiMeetingsUpdateMeetingPut.PATH = '/api/Meetings/UpdateMeeting';
